###*
    @preserve Copyright 2017 Global Village Publishing, Inc.
###


do () ->

    #query = require('querystring')

    #window.onload = () ->
    window.addEventListener('load', () ->

        console.info('methods-map v' + __VERSION__)

        #console.log('ready')
        require('./globals')
        require('./polyfills')
        require('./events')
        #require('normalize.css')
        #require('tests')

        nodeName = ''  # NOTE: this is the root node, empty name
        if window["srm"]["mainsite"] and window["srm"]["mainsite"]["ref"]
            nodeName = window["srm"]["mainsite"]["ref"]
        else
            url = require('url')
            parsed_url = url.parse(location.href)
            if window["srm"]["localhost"] and window["srm"]["localhost"] is true
                path = parsed_url.path
                path_nodes = path.split('/')
                #console.log('path_nodes=', path_nodes)
                #console.log('path_nodes.clean()=', path_nodes.clean())
                path = path_nodes[path_nodes.length - 1]
                if path isnt 'methods-map'
                    #console.log('path=', path)
                    nodeName = path
            else if 0
                query = parsed_url.query
                queries = {}
                if query
                    for q in query.split('&')
                        q2 = q.split('=')
                        queries[q2[0]] = q2[1]
                    if 'name' of queries
                        nodeName = queries['name']
        #console.log('nodeName=', nodeName)
        MapView = require('../map-view/map-view')
        view = new MapView(nodeName)

        if 0
            # NOTE: for comparing font sizes since mobile version is scaled differently
            test_node = document.createElement('div')
            test_node.classList.add('test')
            test_node.style.position = 'absolute'
            if 1
                test_node.innerHTML = 'Research methods are the'
                test_node.style.left = '71px'
                test_node.style.top = '148px'
            else if 1
                test_node.innerHTML = 'Key concepts in research'
                test_node.style.left = '55px'
                test_node.style.top = '648px'
            else
                test_node.innerHTML = 'Recent History'
                test_node.style.left = '119px'
                test_node.style.top = '1032px'
            test_node.style.fontFamily = 'arial'
            test_node.style.fontSize = '16px'
            #console.log(document.body)
            document.body.appendChild(test_node)
            console.log(test_node)

        return
    )


    return

